import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    style={{ margin: "auto 0" }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 13.667A6.667 6.667 0 1 1 7 .334a6.667 6.667 0 0 1 0 13.333Zm-.665-4 4.714-4.714-.943-.943-3.77 3.771-1.887-1.886-.942.943 2.828 2.829Z"
      fill="#13CB75"
    />
  </svg>
);
export default SVGComponent;
